export default __webpack_public_path__ + "static/media/Leonardo_2.401fe2a0.png";